import { mixins } from '@sy/component-library';

const { mediaQueries } = mixins;

export const CONTENT_MAX_WIDTH = 969;

export const CONTENT_VIEWPORT_WIDTH = 90;

export const POST_GRID_GAP = 24;

export const POSTS_PER_ROW_BELOW_MEDIUM = 1;
export const POSTS_PER_ROW_BELOW_LARGE = 2;
export const POSTS_PER_ROW_ABOVE_LARGE = 3;

const MAX_LARGE_IMAGE_WIDTH = Math.ceil(
	(CONTENT_MAX_WIDTH - (POSTS_PER_ROW_ABOVE_LARGE - 1) * POST_GRID_GAP) /
		POSTS_PER_ROW_ABOVE_LARGE,
);

export const REDUCED_CASE_STUDY_IMAGE_SIZES = `${mediaQueries.belowMedium} ${
	CONTENT_VIEWPORT_WIDTH / POSTS_PER_ROW_BELOW_MEDIUM
}vw, ${mediaQueries.belowLarge} ${
	CONTENT_VIEWPORT_WIDTH / POSTS_PER_ROW_BELOW_LARGE
}vw, ${mediaQueries.belowXLarge} ${
	CONTENT_VIEWPORT_WIDTH / POSTS_PER_ROW_ABOVE_LARGE
}vw, ${MAX_LARGE_IMAGE_WIDTH}px`;
